import { useEffect, useMemo, useState } from "react";
import Input from "../../../components/custom/forms/Input";
import ApiRest from "../../../../../hooks/useRest";
import Alerts from "../../../components/Alerts/Alerts";
import ReactQuill from "react-quill";

const MembresiaModal = ({ setModal, data }) => {
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState(data ? data : {
    code: "",
    created_at: "",
    cycle: "",
    descont: "",
    description: "",
    fecha_limite: "",
    history_events: "",
    id: "",
    limit: "",
    limit_cash: "",
    name: "",
    region: "",
    status_id: "",
    suscriptos: "",
    terminos: "",
    updated_at: "",
  })

  const onClick = async (e, value) => {
    switch (e.target.name) {
      case "guardar":
        {

          let formData = new FormData();
          formData.append("name", form.name);
          formData.append("description", form.description);
          formData.append("limit", form.limit);
          formData.append("limit_cash", form.limit_cash);
          formData.append("descont", form.descont);
          formData.append("region", "Cordoba");
          formData.append("cycle", form.cycle);
          formData.append("fecha_limite", form.fecha_limite);
          formData.append("terminos", form.terminos);

          const response = await ApiRest({
            url: "api/membresias",
            form: formData,
            setLoading: setLoading,
          });

          //Error
          if (response.status == 201 || response.status == 200) {
             Alerts({
              msg: "Alert",
              title: response.data.msg,
              code: "401",
              type: "success",
            });
            setModal(false)
          } else {
            if (typeof response.data.msg === "string") {
              return Alerts({
                msg: "Alert",
                title: response.data.msg,
                code: "200",
                type: "success",
              });
            }

            Object.keys(response.data.msg).map((key) => {
              return Alerts({
                msg: "Alert",
                title: response.data.msg[key][0],
                code: "401",
                type: "error",
              });
            });
          }

        }
        break;
      case "aplicar": {
        let formData = new FormData();
        formData.append("_method", "PUT");
        formData.append("id", form.id);

        if (form.name) formData.append("name", form.name);

        if (form.description) formData.append("description", form.description);

        if (form.limit) formData.append("limit", form.limit);

        if (form.limit_cash) formData.append("limit_cash", form.limit_cash);

        if (form.descont) formData.append("descont", form.descont);

        if (form.region) formData.append("region", form.region);

        if (form.terminos) formData.append("terminos", form.terminos);

        if (form.fecha_limite) formData.append("fecha_limite", form.fecha_limite);

        if (form.cycle) formData.append("cycle", form.cycle);

        const response = await ApiRest({
          url: "api/membresias",
          form: formData,
          setLoading: setLoading,
        });

        //Error
        if (response.status == 201 || response.status == 200) {
          Alerts({
            msg: "Alert",
            title: response.data.msg,
            code: "401",
            type: "success",
          });
          setModal(false)
        } else {
          if (typeof response.data.msg === "string") {
            return Alerts({
              msg: "Alert",
              title: response.data.msg,
              code: "200",
              type: "error",
            });
          }

          Object.keys(response.data.msg).map((key) => {
            return Alerts({
              msg: "Alert",
              title: response.data.msg[key][0],
              code: "401",
              type: "error",
            });
          });
        }
      } break;
    }
  };

  const onChange = (e, value) => {
    switch (e.target.name) {
      case "description":
      case "limit":
      case "limit_cash":
      case "descont":
      case "region":
      case "cycle":
      case "fecha_limite":
      case "terminos":
      case "name":
        {
          setForm({
            ...form,
            [e.target.name]: e.target.value
          })
        }
        break;
    }
  };

  let tym = form.terminos;
  const ciclos = [
    { id: 1, mes: "Enero" },
    { id: 2, mes: "Febrero" },
    { id: 3, mes: "Marzo" },
    { id: 4, mes: "Abril" },
    { id: 5, mes: "Mayo" },
    { id: 6, mes: "Junio" },
    { id: 7, mes: "Julio" },
    { id: 8, mes: "Agosto" },
    { id: 9, mes: "Septiembre" },
    { id: 10, mes: "Octubre" },
    { id: 11, mes: "Noviembre" },
    { id: 12, mes: "Diciembre" },
  ]



  const handleChange = (value) => {
    // Validar que no contenga emojis
    const emojiRegex = /[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F1E0}-\u{1F1FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{FE00}-\u{FE0F}\u{1F004}\u{1F0CF}\u{1F18E}\u{3030}\u{2B50}\u{2B55}\u{231A}-\u{231B}\u{23E9}-\u{23EC}\u{23F0}\u{23F3}\u{25FD}-\u{25FE}\u{2614}-\u{2615}\u{2648}-\u{2653}\u{267F}\u{2693}\u{26A1}\u{26AA}-\u{26AB}\u{26BD}-\u{26BE}\u{26C4}-\u{26C5}\u{26CE}\u{26D4}\u{26EA}\u{26F2}-\u{26F3}\u{26F5}\u{26FA}\u{26FD}\u{2705}\u{270A}-\u{270B}\u{2728}\u{274C}\u{274E}\u{2753}-\u{2755}\u{2757}\u{2795}-\u{2797}\u{27B0}\u{27BF}\u{2B1B}-\u{2B1C}]/gu;

    if (emojiRegex.test(value)) {
      Alerts({
        msg: "Warning",
        title: "No se permiten emojis en la descripción del evento",
        code: "400",
        type: "error",
      });
      return;
    }

    setForm({
      ...form,
      terminos: value,
    });
  }


  const modules = useMemo(() => ({
    toolbar: {
      container: [
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
        ['bold', 'italic', 'underline', 'strike'],
        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
        [{ 'align': [] }],
        ['link', 'image', 'video'],
        ['clean']
      ],
      handlers: {
        video: function () {
          const url = prompt('Ingresa la URL del video de YouTube:');
          if (url) {
            let embedUrl = url;

            // Convertir URL de YouTube a formato embed
            if (url.includes('youtube.com/watch?v=')) {
              const videoId = url.split('v=')[1].split('&')[0];
              embedUrl = `https://www.youtube.com/embed/${videoId}`;
            } else if (url.includes('youtu.be/')) {
              const videoId = url.split('youtu.be/')[1].split('?')[0];
              embedUrl = `https://www.youtube.com/embed/${videoId}`;
            }

            const range = this.quill.getSelection(true);
            this.quill.insertEmbed(range.index, 'video', embedUrl);
            this.quill.setSelection(range.index + 1);
          }
        }
      }
    }
  }), []);
  return (
    <div
      class="modal d-block effect-blur  bg-dark bg-opacity-25 align-middle"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      style={{ zIndex: 104 }}
    >
      <div
        class="bg-light modal-dialog animation-modal my-md-5  overflow-hidden texto-normal"
        style={{ maxWidth: "900px!important;" }}
      >
        <div className="modal-content bg-light">
          <div class="title m-0 bg-white p-4 d-flex justify-content-between">
            <div>
              <h1>Membresia</h1>
              <span class="fs-6 text-muted">Agrega o edita tu membresia. </span>
            </div>
            <div>
              <button
                class="border-0 bg-transparent"
                name="close"
                onFocus={(event) => setModal(false)}
              >
                <i class="bi bi-x-lg"></i>
              </button>
            </div>
          </div>
          <div class="body p-4">
            <div className="row">
              <div className="col-md-6">
                <Input
                  onChange={onChange}
                  label={"Nombre"}
                  name={"name"}
                  type={"text"}
                  value={form.name}
                  svg={""}
                  validate={{ msg: "", status: false }}
                />
              </div>
              <div className="col-md-6">
                <Input
                  onChange={onChange}
                  label={"Descuento por entrada %%"}
                  name={"descont"}
                  type={"number"}
                  value={form.descont}
                  svg={""}
                  validate={{ msg: "", status: false }}
                  disabled={data ? true : false}
                />
              </div>
              <div className="col-md-6">
                <label
                  className="form-label text-muted mt-2"
                  style={{ fontSize: "14px" }}
                >
                  Provincia
                </label>
                <select class="form-select" aria-label="Default select example" disabled>
                  <option select>{'Córdoba'}</option>
                </select>
              </div>
              <div className="col-md-6">
                <label
                  className="form-label text-muted mt-2"
                  style={{ fontSize: "14px" }}
                >
                  Ciclo Activo
                </label>
                <select class="form-select" aria-label="Default select example"
                  name="cycle" onChange={(event) => onChange(event)}>
                  {
                    ciclos.map((c, index) => {
                      if (form.ciclos == c.id) {
                        return <option selected>{c.mes}</option>
                      } else {
                        return <option value={c.id}>{c.mes}</option>
                      }
                    })
                  }
                </select>
              </div>
              <div className="col-md-6">
                <Input
                  onChange={onChange}
                  label={"Limite de entradas / Cantidad"}
                  name={"limit"}
                  type={"number"}
                  value={form.limit}
                  svg={""}
                  validate={{ msg: "", status: false }}
                  disabled={false}
                />
              </div>
              <div className="col-md-6">
                <Input
                  onChange={onChange}
                  label={"Limite de gasto / Monto"}
                  name={"limit_cash"}
                  type={"number"}
                  value={form.limit_cash}
                  svg={""}
                  validate={{ msg: "", status: false }}
                  disabled={false}
                />
              </div>
              <div className="col-md-6 d-none">
                <Input
                  onChange={onChange}
                  label={"Fecha limite"}
                  name={"fecha_limite"}
                  type={"date"}
                  value={form.fecha_limite}
                  svg={""}
                  validate={{ msg: "", status: false }}
                  disabled={false}
                />
              </div>
              <div className="col-md-12">
                <label for="exampleFormControlTextarea1" class="form-label">
                  Descripción
                </label>
                <textarea
                  class="form-control"
                  id="exampleFormControlTextarea1"
                  rows="3"
                  name="description"
                  onChange={(event) => onChange(event)}
                  value={form.description}
                ></textarea>
              </div>
              <div className="col-md-12 mb-3">
                <label htmlFor="">Terminos y condiciones</label>

                <ReactQuill
                  value={form?.terminos}
                  onChange={handleChange}
                  theme="snow"
                  modules={modules}
                />
              </div>
            </div>
          </div>

          <div class="footer bg-white p-4">
            <div class="d-flex justify-content-between">
              <div></div>
              <div>
                {
                  data
                    ?
                    <label className=" btn btn-custom-naranja text-white fw-normal GothamBold text-nowrap rounded-pill mx-1 my-2 px-3 py-2 fs-10">
                      <i class="bi bi-chevron-double-left"></i> Aplicar
                      <button
                        className="d-none"
                        name="aplicar"
                        onClick={(event) => onClick(event, data)}
                      ></button>
                    </label>
                    :
                    <label className="btn btn-custom-naranja text-white fw-normal GothamBold text-nowrap rounded-pill mx-1 my-2 px-3 py-2 fs-10">
                      <i class="bi bi-chevron-double-left"></i> Guardar
                      <button
                        className="d-none"
                        name="guardar"
                        onClick={(event) => onClick(event, data)}
                      ></button>
                    </label>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MembresiaModal;
